import lLoading from './src/index'

export default {
  install(Vue) {
    Vue.prototype.$lLoading = lLoading
  }
}

export {lLoading}

